import { render } from "./teachStudio.vue?vue&type=template&id=5ccd3636&scoped=true"
import script from "./teachStudio.vue?vue&type=script&lang=js"
export * from "./teachStudio.vue?vue&type=script&lang=js"

import "./teachStudio.vue?vue&type=style&index=0&id=5ccd3636&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ccd3636"]])

export default __exports__